import { Col, Row } from 'antd';
import _ from 'lodash';
import styled from 'styled-components';
import CardV from '../cards/card-v';

const SectionNews = ({ data, readMore = true }) => {
  if (_.isEmpty(data?.data)) return null;
  // console.log('SectionNews', data);
  const clonData = _.slice(data?.data, 0, 6);
  if (_.isEmpty(data)) return null;
  const linkURL = 'https://komchadluek.net';

  return (
    <>
      <SectionWrapper className='section-news border-gradient'>
        <div className='container background'>
          <div className='logo-title'>
            <img
                className='logo-title'
                src={data?.logo}
                alt='header'
                width='100%'
                height='100%'
                />
          </div>
          <Row gutter={[16, 16]} justify='center' className='grid-news' >
            {_.isArray(clonData) &&
              clonData.map((item, index) => (
                <Col key={index} xs={24} md={12}>
                  <CardV
                    external
                    externalLink={'https://media.komchadluek.net'}
                    data={item}
                    link={linkURL}
                  />
                </Col>
              ))}
            {readMore && (
              <a href={data?.link} className='read-more-button' target='_blank'>
                <div className='read-more'>อ่านข่าวทั้งหมด</div>
              </a>
            )}
          </Row>
        </div>
      </SectionWrapper>
    </>
  );
};

const SectionWrapper = styled.section`
  position: relative;
  display: block;
  z-index: 2;
  border-radius: 30px;
  max-width: 1200px;
  margin: 120px auto 30px;  
  @media (max-width: 768px) {
    margin: 50px auto 30px;  
  }
  &.border-gradient {
   border: 5px solid rgb(181,181,181);
   background: rgba(86,4,4,1);
   border-radius: 30px;
   background: linear-gradient(0deg, rgba(181,181,181,1) 0%, rgba(82,82,82,1) 12%, rgba(255,255,255,1) 25%, rgba(206,206,206,1) 63%, rgba(98,98,98,1) 83%, rgba(163,163,163,1) 100%); 
   .background {
     border-radius: 24px;
     background: rgb(149,14,14);
     background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(86,4,4,1) 50%);
   }
  }
  .grid-news {
    width: 100%;
    max-width: 90%;
    margin: auto !important;
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
  .container {
    display: block;
    margin: auto;
    width: 100%;
    margin: auto;
    padding: 30px;
    border-radius: 30px;
    .logo-title {
      position: relative;
      display: block;
      max-width: 100%;
      width: 80%;
      height: auto;
      margin: auto auto 40px;
      mix-blend-mode: screen;
    }
    @media (max-width: 768px) {
      padding: 10px;
      .logo-title {

      width: 90%;
      margin: 20px auto;
      }
    }

    .read-more-button {
      cursor: pointer;
    }
    .read-more {
      cursor: pointer;
      background: rgb(149,14,14);
      background: linear-gradient(0deg, rgba(149,14,14,1) 0%, rgba(86,4,4,1) 60%);

      border-radius: 22px;
      border: 2px solid rgba(181,181,181,1);
      max-width: 200px;
      display: block;
      text-align: center;
      font-size: 18pt;
      float: left;
      padding: 2px 15px 0px;
      line-height: 1.65;
      margin-top: 1rem;

      color: rgba(181,181,181,1);
      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }
`;

export default SectionNews;
